import { render, staticRenderFns } from "./api-resource-logs.vue?vue&type=template&id=36d26446&"
import script from "./api-resource-logs.vue?vue&type=script&lang=js&"
export * from "./api-resource-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports